import dynamic from 'next/dynamic';

const Citi = dynamic(() => import(`@/assets/CompanyLogos/Citi.svg`));
const JustEat = dynamic(() => import(`@/assets/CompanyLogos/JustEat.svg`));
const WGSN = dynamic(() => import(`@/assets/CompanyLogos/WGSN.svg`));
const Capita = dynamic(() => import(`@/assets/CompanyLogos/Capita.svg`));
const Box = dynamic(() => import(`@/assets/CompanyLogos/Box.svg`));
const EssexCountyCouncil = dynamic(
  () => import(`@/assets/CompanyLogos/EssexCountyCouncil.svg`),
);
const Meta = dynamic(() => import(`@/assets/CompanyLogos/Meta.svg`));
const HargreavesLansdown = dynamic(
  () => import(`@/assets/CompanyLogos/HargreavesLansdown.svg`),
);
const CheshireAndWestChester = dynamic(
  () => import(`@/assets/CompanyLogos/CheshireAndWestChester.svg`),
);
const GoldsmithsUOL = dynamic(
  () => import(`@/assets/CompanyLogos/GoldsmithsUOL.svg`),
);
const Unilever = dynamic(() => import(`@/assets/CompanyLogos/Unilever.svg`));
const Google = dynamic(() => import(`@/assets/CompanyLogos/Google.svg`));
const LondonBusinessSchool = dynamic(
  () => import(`@/assets/CompanyLogos/LondonBusinessSchool.svg`),
);
const MorganStanley = dynamic(
  () => import(`@/assets/CompanyLogos/MorganStanley.svg`),
);
const JLR = dynamic(() => import(`@/assets/CompanyLogos/JLR.svg`));
const KPMG = dynamic(() => import(`@/assets/CompanyLogos/KPMG.svg`));
const CBRE = dynamic(() => import(`@/assets/CompanyLogos/CBRE.svg`));
const TheCrownEstate = dynamic(
  () => import(`@/assets/CompanyLogos/TheCrownEstate.svg`),
);
const HCLTech = dynamic(() => import(`@/assets/CompanyLogos/HCLTech.svg`));
const LaingORourke = dynamic(
  () => import(`@/assets/CompanyLogos/LaingORourke.svg`),
);
const Mastercard = dynamic(
  () => import(`@/assets/CompanyLogos/Mastercard.svg`),
);
const RollsRoyce = dynamic(
  () => import(`@/assets/CompanyLogos/RollsRoyce.svg`),
);
const Verizon = dynamic(() => import(`@/assets/CompanyLogos/Verizon.svg`));
const KeeleUniversity = dynamic(
  () => import(`@/assets/CompanyLogos/KeeleUniversity.svg`),
);
const Microsoft = dynamic(() => import(`@/assets/CompanyLogos/Microsoft.svg`));
const Clover = dynamic(() => import(`@/assets/CompanyLogos/Clover.svg`));
const EDF = dynamic(() => import(`@/assets/CompanyLogos/EDF.svg`));

export const companyLogos = {
  Box,
  Capita,
  CBRE,
  CheshireAndWestChester,
  Citi,
  Clover,
  EDF,
  EssexCountyCouncil,
  GoldsmithsUOL,
  Google,
  HargreavesLansdown,
  HCLTech,
  JLR,
  JustEat,
  KeeleUniversity,
  KPMG,
  LaingORourke,
  LondonBusinessSchool,
  Mastercard,
  Meta,
  Microsoft,
  MorganStanley,
  RollsRoyce,
  TheCrownEstate,
  Unilever,
  Verizon,
  WGSN,
};
